export default __webpack_public_path__ + "static/media/icon-zoom.85da375d.svg";